module.exports = __webpack_public_path__ + "img/reserved_1.df4f02ba.jpg";